module.exports = __webpack_public_path__ + "images/imagelogo.d334c3c0.png";